import React from 'react';
import { times } from 'lodash';
import { Box, FormControl, Slider, useMediaQuery, useTheme } from '@mui/material';
import { useField } from 'formik';
import { AgeSelector } from './constants';

const { minAge, maxAge, minDiff } = AgeSelector;
const steps = (maxAge - minAge) / minDiff + 1;

export function AgeRangeSelector() {
  const [field, meta, helpers] = useField('ageRange');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const labelStep = isMobile ? 20 : 5;
  const marks = times(steps, (index) => {
    const val = index * minDiff + minAge;
    return { label: val % labelStep === 0 ? val : '', value: val };
  });

  const handleChange = (_event: Event, newValue: number | number[]) => {
    helpers.setValue(newValue as number[], true);
    helpers.setTouched(true, false);
  };

  return (
    <FormControl className="flex flex-col gap-2 w-full relative" fullWidth>
      <Box className="flex items-center w-full px-4">
        <Slider
          value={field.value}
          onChange={handleChange}
          onBlur={field.onBlur}
          name={field.name}
          disableSwap
          min={minAge}
          max={maxAge}
          step={minDiff}
          marks={marks}
          valueLabelDisplay="auto"
          className="w-full"
          sx={{ '& .MuiSlider-markLabel': { fontSize: { xs: 10, sm: 'inherit' } } }}
        />
      </Box>
    </FormControl>
  );
}
